'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "colorSet", "className", "contextual", "children", "onClose", "renderIcon", "renderMessage", "renderCloseButton", "iconAriaLabel", "closeButtonAriaLabel"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet } from "../../styles/index.mjs";
import { CloseButton } from "./CloseButton.mjs";
import { Icon } from "./Icon.mjs";
import { Message } from "./Message.mjs";
import { Wrapper } from "./Wrapper.mjs";
var defaultIconRender = function defaultIconRender(props) {
  return /*#__PURE__*/React.createElement(Icon, props);
};
var defaultMessageRender = function defaultMessageRender(props) {
  return /*#__PURE__*/React.createElement(Message, props);
};
var defaultCloseButtonRender = function defaultCloseButtonRender(props) {
  return /*#__PURE__*/React.createElement(CloseButton, props);
};
var getIconAriaLabel = function getIconAriaLabel(bannerColorSet) {
  switch (bannerColorSet) {
    case 'negative':
      return 'Error:';
    case 'warning':
      return 'Warning:';
    case 'positive':
      return 'Success:';
    case 'announcement':
      return 'Announcement:';
    default:
      return 'Info:';
  }
};
var BannerComponent = /*#__PURE__*/React.forwardRef(function BannerComponent(_ref, ref) {
  var align = _ref.align,
    colorSet = _ref.colorSet,
    className = _ref.className,
    _ref$contextual = _ref.contextual,
    contextual = _ref$contextual === void 0 ? false : _ref$contextual,
    children = _ref.children,
    onClose = _ref.onClose,
    _ref$renderIcon = _ref.renderIcon,
    renderIcon = _ref$renderIcon === void 0 ? defaultIconRender : _ref$renderIcon,
    _ref$renderMessage = _ref.renderMessage,
    renderMessage = _ref$renderMessage === void 0 ? defaultMessageRender : _ref$renderMessage,
    _ref$renderCloseButto = _ref.renderCloseButton,
    renderCloseButton = _ref$renderCloseButto === void 0 ? defaultCloseButtonRender : _ref$renderCloseButto,
    _ref$iconAriaLabel = _ref.iconAriaLabel,
    iconAriaLabel = _ref$iconAriaLabel === void 0 ? getIconAriaLabel(colorSet) : _ref$iconAriaLabel,
    _ref$closeButtonAriaL = _ref.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref$closeButtonAriaL === void 0 ? 'Close' : _ref$closeButtonAriaL,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    "data-encore-id": ENCORE_DATA_IDS.Banner,
    className: addColorSet(colorSet, className),
    ref: ref,
    $colorSet: colorSet,
    $align: align,
    $contextual: contextual,
    $showClose: onClose ? true : undefined
  }, props), renderIcon({
    colorSet: colorSet,
    iconAriaLabel: iconAriaLabel
  }), renderMessage({
    children: children,
    align: align
  }), onClose && renderCloseButton({
    onClose: onClose,
    closeButtonAriaLabel: closeButtonAriaLabel
  }));
});
var bannerHelpers = {
  /**
   * @deprecated
   */
  Icon: Icon,
  /**
   * @deprecated
   */
  Message: Message,
  /**
   * @deprecated
   */
  CloseButton: CloseButton
};
export var Banner = Object.assign(BannerComponent, bannerHelpers);